export function ArrowCircle({ className = "w-4" }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10ZM18.75 10C18.75 5.18 14.82 1.25 10 1.25C5.18 1.25 1.25 5.18 1.25 10C1.25 14.82 5.18 18.75 10 18.75C14.82 18.75 18.75 14.82 18.75 10ZM14.82 9.56C14.94 9.68 15 9.84 15 10C15 10.16 14.94 10.32 14.82 10.44L11.07 14.19C10.83 14.43 10.43 14.43 10.19 14.19C9.95 13.95 9.95 13.55 10.19 13.31L12.87 10.63H5.62C5.27 10.63 5 10.35 5 10.01C5 9.67 5.28 9.39 5.62 9.39H12.86L10.18 6.71C9.94 6.47 9.94 6.07 10.18 5.83C10.42 5.59 10.82 5.59 11.06 5.83L14.81 9.58L14.82 9.56Z"
        fill="currentColor"
      />
    </svg>
  );
}
